module.exports = __webpack_public_path__ + "img/intro_s3_icon3.84f28d13.png";